import React from 'react'
import { Link } from 'react-router-dom'

function Footer() {
    return (
        <>
            {/* Footer Start */}
            <footer className="footer mt-auto py-3 bg-white text-center">
                <div className="container">
                    <span className="text-muted">
                        {" "}
                        Copyright © <span id="year" />{" "}
                        <Link to="#" className="text-dark fw-semibold">
                            XBit Trade
                        </Link>
                        . Designed & Developed <span className="bi bi-heart-fill text-danger" /> by{" "}
                        <Link to="www.raitechcorporation.com">
                            <span className="fw-semibold text-primary text-decoration-underline">
                                Rai Tech Corporation
                            </span>
                        </Link>{" "}
                        All rights reserved
                    </span>
                </div>
            </footer>
            {/* Footer End */}
        </>
    )
}

export default Footer